import { proxy } from 'valtio';
export const trendStore = proxy({
    state: '---',
});
